var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10206",
    "data-name": "Group 10206",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13.974,
    height: 13.974,
    viewBox: "0 0 13.974 13.974",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2232",
    "data-name": "Rectangle 2232",
    width: 13.974,
    height: 13.974,
    fill: "#152c40"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10205",
    "data-name": "Group 10205",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27571",
    "data-name": "Path 27571",
    d: "M10.713,13.974a1.473,1.473,0,0,1-1.4-1.4v-.466H4.658v.466a1.4,1.4,0,0,1-1.4,1.4,1.473,1.473,0,0,1-1.4-1.4v-.466H1.4a1.351,1.351,0,0,1-1.4-1.4V6.987A1.4,1.4,0,0,1,1.088,5.624l.6-3.653A2.37,2.37,0,0,1,4.008,0H9.874a2.368,2.368,0,0,1,2.32,1.956l.6,3.653a1.486,1.486,0,0,1,1.183,1.378v3.726a1.351,1.351,0,0,1-1.4,1.4h-.466v.466a1.4,1.4,0,0,1-1.4,1.4M4.192,11.179h5.59a.466.466,0,0,1,.466.466v.932a.545.545,0,0,0,.466.466.467.467,0,0,0,.466-.466v-.932a.466.466,0,0,1,.466-.466h.932a.42.42,0,0,0,.466-.466V6.987a.545.545,0,0,0-.466-.466h-.184a.467.467,0,0,1-.461-.39l-.655-4.01a1.422,1.422,0,0,0-1.4-1.19H4.008A1.427,1.427,0,0,0,2.6,2.138L1.949,6.131a.465.465,0,0,1-.46.39.5.5,0,0,0-.558.466v3.726a.42.42,0,0,0,.466.466h.932a.466.466,0,0,1,.466.466v.932a.545.545,0,0,0,.466.466.468.468,0,0,0,.466-.466v-.932a.466.466,0,0,1,.466-.466m6.521-.932a1.351,1.351,0,0,1-1.4-1.4,1.4,1.4,0,1,1,2.795,0,1.4,1.4,0,0,1-1.4,1.4m0-1.863a.42.42,0,0,0-.466.466.42.42,0,0,0,.466.466.467.467,0,0,0,.466-.466.42.42,0,0,0-.466-.466M3.261,10.248a1.351,1.351,0,0,1-1.4-1.4,1.351,1.351,0,0,1,1.4-1.4,1.351,1.351,0,0,1,1.4,1.4,1.4,1.4,0,0,1-1.4,1.4m0-1.863a.42.42,0,0,0-.466.466.42.42,0,0,0,.466.466.468.468,0,0,0,.466-.466.42.42,0,0,0-.466-.466M10.53,6.521H3.353a.466.466,0,0,1-.458-.547L3.55,2.248a.465.465,0,0,1,.458-.385H9.874a.465.465,0,0,1,.458.385l.656,3.726a.466.466,0,0,1-.458.547M3.908,5.59H9.974L9.484,2.795H4.4Z",
    fill: "#152c40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon4);
export default __webpack_public_path__ + "static/media/social-icon4.c73a75cfaea99887cdb90d8bc660edab.svg";
export { ForwardRef as ReactComponent };